import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_DISCOUNT_SESSIONS, propTypes } from '../../util/types';
import classNames from 'classnames';
import InfoTooltip from '../InfoTooltip/InfoTooltip';

import css from './OrderBreakdown.module.css';

const LineItemSessionsDiscount = props => {
  const { transaction, intl, isEstimated, sessionsDiscount, isProvider } = props;
  const sessionsDiscountLineItem = transaction.attributes.lineItems.find(
    item => item.code === LINE_ITEM_DISCOUNT_SESSIONS && !item.reversal
  );

  if (!sessionsDiscountLineItem || !sessionsDiscount) return null;

  const { lineTotal } = sessionsDiscountLineItem;

  // For customers: apply customer fee to display (frontend only)
  // For providers: show base price
  // Note: discount is negative, multiplying by (1 + fee%) makes it more negative
  const isCustomer = !isProvider;
  const customerCommissionLineItem = isCustomer
    ? transaction.attributes.lineItems.find(
        item => item.code === 'line-item/customer-commission' && !item.reversal
      )
    : null;
  const customerFeePercentage = customerCommissionLineItem?.percentage || 0;

  const displayAmount = isCustomer && customerFeePercentage > 0
    ? lineTotal.amount * (1 + customerFeePercentage / 100)
    : lineTotal.amount;

  const { types } = require('../../util/sdkLoader');
  const { Money } = types;
  const displayTotal = new Money(displayAmount, lineTotal.currency);

  const total = formatMoney(intl, displayTotal, true);

  return (
    <div className={css.lineItem}>
      <span className={classNames(css.itemLabel, { [css.itemGray]: !isEstimated })}>
        <FormattedMessage id="General.discount" />
        <InfoTooltip id="BookingBreakdown.seasonDiscountTooltip" triggerClassName={css.feeTooltip}>
          <FormattedMessage
            id="BookingTimeForm.seasonDiscount"
            values={{
              fromSession: (sessionsDiscount.fromSession || 0) + 1,
              percent: sessionsDiscount.percent,
            }}
          />
        </InfoTooltip>
      </span>
      <span className={css.itemValue}>{total}</span>
    </div>
  );
};

LineItemSessionsDiscount.propTypes = {
  transaction: propTypes.transaction.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemSessionsDiscount;
